import { putApi } from "../helpers/auth_helpers";

const base = process.env.REACT_APP_SERVERURL || "";

/** Studio admin or manager: set a person's Studio ID. 409 message when someone in the studio has it. */
export const updateStudioId = (userId: string, studioId: string) =>
  putApi(`${base}/user/studio-id`, { userId, studioId });
